export default __webpack_public_path__ + "static/media/logo-bangkok-happy-bowl.6680b4fe.png";